export const colors = {
    black: '#000',
    white: '#fff',
    pink: {
        50: '#FEE3EE',
        100: '#FDB8D5',
        200: '#fbcfe8',
        300: '#FE539C',
        400: '#FE1284',
        500: '#FF006B',
        600: '#ED0069',
        700: '#D60064',
        800: '#C10061',
        900: '#9A005B'
    },
    purple: {
        50: '#FAF5FF',
        100: '#F3E8FF',
        200: '#E9D5FF',
        300: '#D8B4FE',
        400: '#BC05FF',
        500: '#AE00FD',
        600: '#9900F8',
        700: '#7A00F3',
        800: '#5A00F0',
        900: '#0000E5'
    },
    indigo: {
        50: '#E9EAF6',
        100: '#C7CAE9',
        200: '#A3A8D9',
        300: '#7F86CA',
        400: '#646BBE',
        500: '#4B50B3',
        600: '#4548A9',
        700: '#3C3E9D',
        800: '#353491',
        900: '#28227C'
    },
    blue: {
        50: '#DCF2FF',
        100: '#BBDDF4',
        200: '#9FC3DF',
        300: '#80AAC9',
        400: '#6896B7',
        500: '#4F83A7',
        600: '#417494',
        700: '#31607D',
        800: '#234D67',
        900: '#0E384E'
    },
    emerald: {
        50: '#F4F9E6',
        100: '#E4F1C0',
        200: '#D1E797',
        300: '#BDDE6B',
        400: '#ADD644',
        500: '#9DCE0B',
        600: '#8CBE00',
        700: '#75AA00',
        800: '#5E9700',
        900: '#367500'
    },
    amber: {
        50: '#FBFCE7',
        100: '#F6F6C5',
        200: '#F0F09E',
        300: '#EBEA79',
        400: '#E7E55D',
        500: '#E4E144',
        600: '#E3D03D',
        700: '#E1B933',
        800: '#DFA228',
        900: '#D97D15'
    },
    orange: {
        50: '#FBF2E1',
        100: '#F5DEB4',
        200: '#EFCA84',
        300: '#EAB454',
        400: '#E6A534',
        500: '#E3971E',
        600: '#DF8C1A',
        700: '#D97E15',
        800: '#D26F11',
        900: '#C8590D'
    },
    red: {
        50: '#FDEBED',
        100: '#FBCDCF',
        200: '#E79B96',
        300: '#DA766E',
        400: '#E25A4A',
        500: '#E44F30',
        600: '#D6452F',
        700: '#C43C2A',
        800: '#B73623',
        900: '#A82E19'
    },
    gray: {
        50: '#F9FAFB',
        100: '#F3F4F6',
        150: '#EEEFF0',
        200: '#E5E7EB',
        300: '#D1D5DB',
        400: '#9CA3AF',
        500: '#6B7280',
        600: '#4B5563',
        700: '#374151',
        800: '#1F2937',
        900: '#111827'
    }
};
//# sourceMappingURL=colors.js.map